<template>
  <div
    @mouseenter="isShowTip = true"
    @mouseleave="isShowTip = false"
    class="w-6 h-6 border border-gray-600 rounded flex justify-center relative"
    :class="[selected ? 'bg-teal-500' : '', type]"
  >
    <div
      class="m-auto w-4 h-4 t-col text-center text-xxs"
      :class="[color, type]"
      ref="round"
    >{{text}}</div>
    <div
      v-if="isShowTip"
      class="absolute top-0 bg-black -mt-6 text-white text-xs rounded px-2 z-30 w-32 text-center"
    >{{tooltip}}</div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "VColorButton",
  props: {
    type: { default: "rounded-full" },
    color: { default: "" },
    styleColor: { default: "" },
    text: { default: "" },
    tooltip: { default: "" },
    selected: { default: false }
  },
  data() {
    return {
      isShowTip: false
    };
  },
  mounted() {
    this.setColor(this.styleColor);
    this.$watch("styleColor", () => {
      this.setColor(this.styleColor);
    });
  },
  computed: {},
  methods: {
    setColor(color) {
      this.$refs.round.style.background = color;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.t-col {
  color: rgb(224, 227, 230);
}
</style>
